import { Container } from './style';

import type { ReactNode } from 'react';
import type React from 'react';

interface ModalProps {
  children?: ReactNode;
  className?: string;
}

export const Modal: React.FC<ModalProps> = (props) => {
  return <Container {...props}>{props.children}</Container>;
};
